import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";
import congrats from "assets/images/components/pages/onboard/congrats.png";

const AppSuccessfulModal = (props, ref) => {
	const [visible, setVisible] = useState(false);
    const {onClick} = props;

	const onHandleShow = useCallback(() => {
		setVisible(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
        onClick?.();
	}, [onClick]);

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-successful-modal" }} open={visible} aria-labelledby="app-successful" aria-describedby="app-successful">
			<div className="successful-modal">
				<img className="successful-modal__congrats" src={congrats} alt="congrats" />

				<div className="successful-modal__header">
					<p className="successful-modal__title">Password has reset!</p>
					<p className="successful-modal__description">Your password has been reset successfully!</p>
					<p className="successful-modal__description">Please login with new password.</p>
				</div>

				<div className="successful-modal__button-container">
					<AppButton type="button" label="Done" onClick={onHandleDismiss} />
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppSuccessfulModal));

AppSuccessfulModal.propTypes = {
	ref: PropTypes.object,
};
